import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdCheckCircle,
  MdDelete,
  MdEdit,
  MdEventNote,
  MdClose,
  MdMail,
  MdPhone,
  MdLocationOn,
  MdBusiness,
  MdGroup,
  MdAssignment,
  MdVisibility,
} from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import CountUp from "react-countup";
import { ExclamationCircleFilled } from "@ant-design/icons";
import api from "../../../services/api";
import { Card, HeaderTitle, ViewInput, Message } from "../../../GlobalStyles";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  Input,
  Pagination,
  Select,
  DatePicker,
  Switch,
  Spin,
  Tooltip,
} from "antd";
import {
  Container,
  TypeSelector,
  AssociateInfo,
  InfoTag,
  Label,
} from "./styles";
import { addDays, format, isBefore, startOfDay } from "date-fns";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { useQuery } from "../../../hooks/Location";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/AuthContext";
import userPhoto from "../../../images/user.png";
import { getValue } from "../../../services/functions";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

dayjs.extend(weekday);
dayjs.extend(localeData);

const { confirm } = Modal;

const Lembretes = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const query = useQuery();

  const [reminders, setReminders] = useState([]);
  const [leadId, setLeadId] = useState(query.get("lead") || "");
  const [orderId, setOrderId] = useState(query.get("order") || "");
  const [date, setDate] = useState("");
  const [dateRenewal, setDateRenewal] = useState("");
  const [reminderType, setReminderType] = useState("task");
  const [ordersAll, setOrdersAll] = useState([]);
  const [leadsAll, setLeadsAll] = useState([]);
  const [remindersTotal, setRemindersTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [lead, setLead] = useState(query.get("lead") || "");
  const [order, setOrder] = useState(query.get("lead") || "");
  const [page, setPage] = useState(0);
  const [id, setId] = useState("");
  const [dateStart, setDateStart] = useState(addDays(new Date(), -30));
  const [dateEnd, setDateEnd] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [isOpenLead, setIsOpenLead] = useState(false);
  const [isOpenDetails, setIsOpenDetails] = useState(false);
  const [leadSelected, setLeadSelected] = useState({});
  const [reminderSelected, setReminderSelected] = useState({});
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [all, setAll] = useState(true);
  const [repeat, setRepeat] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    loadReminders(page, all, lead, order, dateStart, dateEnd, status);
  }, [page, all, lead, order, dateStart, dateEnd, status]);

  useEffect(() => {
    loadLeadsAll();
    loadOrdersAll();
  }, []);

  async function loadReminders(
    page,
    all,
    lead,
    order,
    dateStart,
    dateEnd,
    status,
  ) {
    setIsLoading(true);
    let url = `/reminders?page=${page}`;
    if (!all)
      url += `&dateStart=${dateStart.toISOString()}&dateEnd=${dateEnd.toISOString()}`;
    if (lead) url += `&lead_id=${lead}`;
    if (status) url += `&status=${status}`;

    await api
      .get(url)
      .then((response) => {
        setReminders(response.data.reminders);
        setRemindersTotal(response.data.remindersTotal);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function loadLeadsAll() {
    await api
      .get(`/my-leads?all=true`)
      .then((response) => {
        setLeadsAll(response.data);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadOrdersAll() {
    await api
      .get(`/orders/cliente?all=true`)
      .then((response) => {
        setOrdersAll(response.data);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function createReminder() {
    setIsLoadingModal(true);
    if (!name || !date) {
      toast.warn("Preencha o nome e data para salvar");
      setIsLoadingModal(false);
      return "";
    }

    if (reminderType == "lead" && !leadId) {
      toast.warn("Selecione o lead para vincular ao lembrete");
      setIsLoadingModal(false);
      return "";
    }

    if (reminderType == "order" && !orderId) {
      toast.warn("Selecione a OS para vincular ao lembrete");
      setIsLoadingModal(false);
      return "";
    }

    if (id) {
      await api
        .put(`/reminder/${id}`, {
          name: name,
          date: date,
          expiration_date: dateRenewal,
          description: description,
        })
        .then(() => {
          toast.success("Lembrete editado com sucesso");
          loadReminders(page, all, lead, order, dateStart, dateEnd, status);
          setIsOpen(false);
        })
        .catch(({ response }) => {
          if (response?.data?.message) {
            toast.warn(response.data.message);
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    } else {
      await api
        .post("/reminder", {
          name: name,
          date: date,
          expiration_date: dateRenewal,
          type: reminderType,
          description: description,
          lead_id: leadId,
          order_id: orderId,
        })
        .then(() => {
          toast.success("Lembrete criado com sucesso");
          loadReminders(page, all, order, order, dateStart, dateEnd, status);
          setIsOpen(false);
        })
        .catch(({ response }) => {
          if (response?.data?.message) {
            toast.warn(response.data.message);
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }

    setIsLoadingModal(false);
  }

  async function deleteReminder(reminder) {
    await api
      .delete(`/reminder/${reminder.id}`)
      .then(() => {
        toast.success("Lembrete deletado com sucesso");
        loadReminders(page, all, lead, order, dateStart, dateEnd, status);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function confirmReminder() {
    setIsLoadingModal(true);
    await api
      .put(`/confirm-reminder/${id}`, {
        name: name,
        description: description,
        repeat: repeat,
        date_repeat: date,
        date_expiration: dateRenewal,
      })
      .then(() => {
        toast.success("Lembrete confirmado com sucesso");
        loadReminders(page, all, lead, order, dateStart, dateEnd, status);
        setIsOpenConfirm(false);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Lembretes</h1>
        <Button
          type="primary"
          style={{ borderRadius: 50 }}
          onClick={() => {
            setDescription("");
            setId("");
            setName("");
            setDate("");
            setDateRenewal("");
            setReminderType("task");
            setIsOpen(true);
          }}
        >
          <MdAdd size="20" color="#fff" />
          <span>Criar Lembrete</span>
        </Button>
      </HeaderTitle>

      <Card>
        <p>Total</p>
        <CountUp
          separator="."
          duration={1}
          end={remindersTotal}
          separator="."
        />
      </Card>

      <div className="filters-row">
        <ViewInput style={{ width: "100%", maxWidth: 265 }}>
          <p>Selecione o Periodo</p>
          <RangePicker
            style={{ width: "100%" }}
            placeholder={["data inicial", "data final"]}
            value={[all ? null : dayjs(dateStart), all ? null : dayjs(dateEnd)]}
            disabled={all}
            format={"DD/MM/YYYY"}
            onChange={(value) => {
              if (value) {
                setDateStart(value[0].toDate());
                setDateEnd(value[1].toDate());
                setAll(false);
              }
              setPage(0);
            }}
          />
        </ViewInput>

        <ViewInput style={{ width: "100%", maxWidth: 120 }}>
          <p>Visualizar</p>
          <Select
            value={all ? "all" : "period"}
            style={{ width: "100%" }}
            onChange={(val) => {
              setAll(val === "all");
              setPage(0);
            }}
          >
            <Select.Option value="all">Todos</Select.Option>
            <Select.Option value="period">Período</Select.Option>
          </Select>
        </ViewInput>

        <ViewInput style={{ width: "100%", maxWidth: 200 }}>
          <p>Filtrar por Lead</p>
          <Select
            placeholder="selecionar lead"
            value={lead || null}
            showSearch
            allowClear
            optionFilterProp="children"
            style={{ width: "100%", textAlign: "left" }}
            onChange={(value) => {
              setLead(value);
              setPage(0);
            }}
          >
            {leadsAll.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </ViewInput>

        <ViewInput style={{ width: "100%", maxWidth: 200 }}>
          <p>Filtrar por OS</p>
          <Select
            placeholder="selecionar os"
            value={order || null}
            showSearch
            allowClear
            optionFilterProp="children"
            style={{ width: "100%", textAlign: "left" }}
            onChange={(value) => {
              setOrder(value);
              setPage(0);
            }}
          >
            {ordersAll.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                OS: {item.id}
              </Select.Option>
            ))}
          </Select>
        </ViewInput>

        <ViewInput style={{ width: "100%", maxWidth: 150 }}>
          <p>Status</p>
          <Select
            value={status}
            style={{ width: "100%", textAlign: "left" }}
            onChange={(value) => {
              setStatus(value);
              setPage(0);
            }}
          >
            <Select.Option value="">Todos</Select.Option>
            <Select.Option value="pendente">Pendente</Select.Option>
            <Select.Option value="concluido">Concluido</Select.Option>
            <Select.Option value="vencido">Vencido</Select.Option>
            <Select.Option value="avencer">À Vencer</Select.Option>
          </Select>
        </ViewInput>
      </div>

      {isLoading ? (
        <div style={{ textAlign: "center", padding: 50 }}>
          <Spin size="large" />
        </div>
      ) : (
        <div className="reminders-list">
          {reminders.length > 0 ? (
            reminders.map((item) => {
              const isVencido =
                !item.confirm &&
                isBefore(new Date(item.date), startOfDay(new Date()));
              const statusClass = item.confirm
                ? "status-concluido"
                : isVencido
                  ? "status-vencido"
                  : "status-pendente";
              const statusText = item.confirm
                ? "Concluido"
                : isVencido
                  ? "Vencido"
                  : "Pendente";

              return (
                <div
                  className="reminder-card"
                  key={item.id}
                  onClick={() => {
                    setReminderSelected(item);
                    setIsOpenDetails(true);
                  }}
                >
                  <div className="main-info">
                    <strong>{item.name}</strong>
                    <span>{item.type || "TASK"}</span>
                  </div>

                  <div className="info-item">
                    <label>Status</label>
                    <span className={statusClass}>{statusText}</span>
                  </div>

                  <div className="info-item">
                    <label>Data Agendada</label>
                    <span>{format(new Date(item.date), "dd/MM/yyyy")}</span>
                  </div>

                  <div className="info-item">
                    <label>Data de Renovação</label>
                    <span>
                      {item.type === "order" && item.expiration_date
                        ? format(new Date(item.expiration_date), "dd/MM/yyyy")
                        : "---"}
                    </span>
                  </div>

                  <div className="info-item">
                    <label>Vinculado a</label>
                    {item.type == "task" ? (
                      <span>Sem vinculação</span>
                    ) : (
                      <Button
                        type="primary"
                        style={{
                          width: "120px",
                          height: 25,
                          fontSize: 12,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (item.type == "order") {
                            navigate(`/cliente/os/${item.order_id}`);
                          } else {
                            const foundLead = leadsAll.find(
                              (l) => l.id === item.lead_id,
                            );
                            if (foundLead) {
                              setLeadSelected(foundLead);
                              setIsOpenLead(true);
                            } else {
                              toast.warn("Lead não encontrado");
                            }
                          }
                        }}
                      >
                        {item.type == "order" ? `OS: ${item.order_id}` : "LEAD"}
                      </Button>
                    )}
                  </div>

                  <div className="info-item">
                    <label>Descrição</label>
                    <Tooltip title={item.description}>
                      <span
                        style={{
                          maxWidth: 150,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.description || "Sem descrição"}
                      </span>
                    </Tooltip>
                  </div>

                  <div
                    className="actions"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <Tooltip title="Ver Detalhes">
                      <Button
                        shape="circle"
                        icon={<MdVisibility size={18} />}
                        onClick={() => {
                          setReminderSelected(item);
                          setIsOpenDetails(true);
                        }}
                      />
                    </Tooltip>
                    {!item.confirm && (
                      <Tooltip title="Confirmar">
                        <Button
                          shape="circle"
                          icon={<MdCheckCircle size={18} color="#008037" />}
                          onClick={() => {
                            setId(item.id);
                            setReminderType(item.type);
                            setRepeat(false);
                            setName(item.name);
                            setDate("");
                            setDateRenewal("");
                            setDescription(item.description);
                            setIsOpenConfirm(true);
                          }}
                        />
                      </Tooltip>
                    )}
                    {!item.confirm && (
                      <Tooltip title="Editar">
                        <Button
                          shape="circle"
                          icon={<MdEdit size={18} />}
                          onClick={() => {
                            setId(item.id);
                            setName(item.name);
                            setDate(item.date);
                            setDateRenewal(item.expiration_date || "");
                            setReminderType(item.type || "task");
                            setLeadId(item.lead_id);
                            setOrderId(item.order_id);
                            setDescription(item.description);
                            setIsOpen(true);
                          }}
                        />
                      </Tooltip>
                    )}
                    <Tooltip title="Excluir">
                      <Button
                        shape="circle"
                        danger
                        icon={<MdDelete size={18} />}
                        onClick={() => {
                          confirm({
                            okText: "Confirmar",
                            title: "Excluir Lembrete?",
                            icon: <ExclamationCircleFilled />,
                            content: `Deseja realmente excluir ${item.name}?`,
                            onOk() {
                              deleteReminder(item);
                            },
                            cancelText: "Cancelar",
                          });
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              style={{
                background: "#fff",
                padding: 50,
                borderRadius: 15,
                textAlign: "center",
                border: "1px solid #eee",
              }}
            >
              <Message>Nenhum lembrete encontrado.</Message>
            </div>
          )}
        </div>
      )}

      <Pagination
        style={{ marginTop: 25, alignSelf: "center" }}
        current={page + 1}
        onChange={(p) => setPage(p - 1)}
        total={remindersTotal}
        pageSize={30}
        showTotal={(total) => `${total} lembretes`}
      />

      <Modal
        title={id ? "Editando lembrete" : "Cadastrando lembrete"}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "Editar" : "Cadastrar"}
        cancelText="Cancelar"
        onOk={createReminder}
        onCancel={() => setIsOpen(false)}
      >
        <ViewInput>
          <p>Tipo de Lembrete</p>
          <TypeSelector>
            <Button
              disabled={!!id}
              className={`type-btn ${reminderType === "task" ? "active" : ""}`}
              onClick={() => setReminderType("task")}
            >
              TAREFA
            </Button>
            <Button
              disabled={!!id}
              className={`type-btn ${reminderType === "lead" ? "active" : ""}`}
              onClick={() => setReminderType("lead")}
            >
              LEAD
            </Button>
            <Button
              disabled={!!id}
              className={`type-btn ${reminderType === "order" ? "active" : ""}`}
              onClick={() => setReminderType("order")}
            >
              OS
            </Button>
          </TypeSelector>
        </ViewInput>

        <ViewInput>
          <p>Nome do Lembrete*</p>
          <Input
            placeholder="Ex: Ligar para cliente"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </ViewInput>

        <div style={{ display: "flex", gap: 15 }}>
          <ViewInput style={{ flex: 1 }}>
            <p>Data do Lembrete*</p>
            <DatePicker
              placeholder="data do lembrete"
              style={{ width: "100%" }}
              value={date ? dayjs(date) : null}
              format={"DD/MM/YYYY"}
              onChange={(val) => setDate(val ? val.toDate() : "")}
            />
          </ViewInput>
          {reminderType == "order" && (
            <ViewInput style={{ flex: 1 }}>
              <p>Data de Renovação</p>
              <DatePicker
                placeholder="data de renovação"
                style={{ width: "100%" }}
                value={dateRenewal ? dayjs(dateRenewal) : null}
                format={"DD/MM/YYYY"}
                onChange={(val) => setDateRenewal(val ? val.toDate() : "")}
              />
            </ViewInput>
          )}
        </div>

        {reminderType == "lead" && (
          <ViewInput>
            <p>Vincular a Lead*</p>
            <Select
              disabled={id}
              placeholder={`Selecione o lead`}
              value={leadId || null}
              showSearch
              optionFilterProp="children"
              style={{ width: "100%" }}
              onChange={(value) => setLeadId(value)}
            >
              {leadsAll.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </ViewInput>
        )}
        {reminderType == "order" && (
          <ViewInput>
            <p>Vincular a Pedido*</p>
            <Select
              disabled={id}
              placeholder={`Selecione o pedido`}
              value={orderId || null}
              showSearch
              optionFilterProp="children"
              style={{ width: "100%" }}
              onChange={(value) => setOrderId(value)}
            >
              {ordersAll.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  OS: {item.id}
                </Select.Option>
              ))}
            </Select>
          </ViewInput>
        )}

        <ViewInput>
          <p>Descrição</p>
          <TextArea
            rows={4}
            placeholder="Detalhes sobre o lembrete..."
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </ViewInput>
      </Modal>

      <Modal
        title={"Confirmando lembrete"}
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpenConfirm}
        okText="Confirmar"
        cancelText="Cancelar"
        onOk={confirmReminder}
        onCancel={() => setIsOpenConfirm(false)}
      >
        <ViewInput>
          <p>Nome do Lembrete</p>
          <Input disabled value={name} />
        </ViewInput>

        <ViewInput style={{ textAlign: "start", marginTop: 15 }}>
          <p>Agendar repetição?</p>
          <Switch checked={repeat} onChange={(val) => setRepeat(val)} />
        </ViewInput>

        {repeat && (
          <ViewInput>
            <p>Próxima Data*</p>
            <DatePicker
              placeholder="próxima data"
              style={{ width: "100%" }}
              value={date ? dayjs(date) : null}
              format={"DD/MM/YYYY"}
              onChange={(val) => setDate(val ? val.toDate() : "")}
            />
          </ViewInput>
        )}
        {repeat && reminderType == "order" && (
          <ViewInput>
            <p>Próxima Renovação*</p>
            <DatePicker
              placeholder="próxima renovação"
              style={{ width: "100%" }}
              value={dateRenewal ? dayjs(dateRenewal) : null}
              format={"DD/MM/YYYY"}
              onChange={(val) => setDateRenewal(val ? val.toDate() : "")}
            />
          </ViewInput>
        )}

        <ViewInput>
          <p>Observações da Conclusão</p>
          <TextArea
            rows={3}
            placeholder="Alguma nota sobre este lembrete?"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </ViewInput>
      </Modal>

      {/* Modal Detalhado do Lead */}
      <Modal
        width={500}
        open={isOpenLead}
        onCancel={() => setIsOpenLead(false)}
        footer={null}
        closable={false}
        styles={{ content: { padding: 0 } }}
      >
        <div
          style={{
            position: "relative",
            background: "#fff",
            borderRadius: 5,
            padding: "25px 20px 20px 20px",
            borderTop: "30px solid #d7f0db",
          }}
        >
          <MdClose
            style={{
              position: "absolute",
              cursor: "pointer",
              top: -25,
              right: 10,
            }}
            size={20}
            color="#333"
            onClick={() => setIsOpenLead(false)}
          />
          <header
            style={{
              position: "absolute",
              top: -22,
              left: 15,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Label color={"#008037"} />
            <p
              style={{
                marginLeft: 5,
                fontSize: 12,
                fontWeight: 500,
                color: "#000a",
              }}
            >
              Detalhes do Lead
            </p>
          </header>

          <h2 style={{ marginTop: 10, fontSize: 22 }}>{leadSelected.name}</h2>

          <InfoTag>
            {leadSelected.email && (
              <div className="tag">
                <MdMail size={14} /> {leadSelected.email}
              </div>
            )}
            {leadSelected.phone_number && (
              <div className="tag">
                <MdPhone size={14} /> {leadSelected.phone_number}
              </div>
            )}
            {leadSelected.location && (
              <div className="tag">
                <MdLocationOn size={14} /> {leadSelected.location}
              </div>
            )}
            {leadSelected.cnpj && (
              <div className="tag">
                <MdBusiness size={14} /> CNPJ: {leadSelected.cnpj}
              </div>
            )}
            {leadSelected.employees && (
              <div className="tag">
                <MdGroup size={14} /> {leadSelected.employees} func.
              </div>
            )}
            {leadSelected.necessity && (
              <div className="tag">
                <MdAssignment size={14} /> {leadSelected.necessity}
              </div>
            )}
          </InfoTag>

          <div style={{ margin: "15px 0" }}>
            <p style={{ fontSize: 13, color: "#666", marginBottom: 5 }}>
              Observações do Cadastro:
            </p>
            <p style={{ fontSize: 14, fontWeight: "normal", color: "#333" }}>
              {leadSelected.observation || "Sem observações adicionais."}
            </p>
          </div>

          <p
            style={{
              fontSize: 18,
              color: "#008037",
              fontWeight: "bold",
              margin: 0,
            }}
          >
            {getValue(leadSelected.value || 0)}
          </p>

          <div style={{ display: "flex", gap: 15, marginTop: 10 }}>
            {leadSelected.phone_number && (
              <FaWhatsapp
                size={22}
                color="#25D366"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    `https://api.whatsapp.com/send/?phone=55${leadSelected.phone_number}`,
                  )
                }
              />
            )}
            {leadSelected.phone_number && (
              <MdPhone
                size={22}
                color="#333"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`tel:${leadSelected.phone_number}`)}
              />
            )}
            {leadSelected.email && (
              <MdMail
                size={22}
                color="#EA4335"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`mailto:${leadSelected.email}`)}
              />
            )}
          </div>

          {leadSelected.user && (
            <AssociateInfo>
              <img
                src={
                  leadSelected.user.photo
                    ? leadSelected.user.photo_url
                    : userPhoto
                }
                alt="Perfil"
              />
              <div className="info">
                <span>Cadastrado por:</span>
                <strong>{leadSelected.user.name}</strong>
              </div>
            </AssociateInfo>
          )}
        </div>
      </Modal>

      {/* Modal Detalhado do Lembrete */}
      <Modal
        width={500}
        open={isOpenDetails}
        onCancel={() => setIsOpenDetails(false)}
        footer={null}
        closable={false}
        styles={{ content: { padding: 0 } }}
      >
        <div
          style={{
            position: "relative",
            background: "#fff",
            borderRadius: 5,
            padding: "25px 20px 20px 20px",
            borderTop: "30px solid #d7f0db",
          }}
        >
          <MdClose
            style={{
              position: "absolute",
              cursor: "pointer",
              top: -25,
              right: 10,
            }}
            size={20}
            color="#333"
            onClick={() => setIsOpenDetails(false)}
          />
          <header
            style={{
              position: "absolute",
              top: -22,
              left: 15,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Label color={"#008037"} />
            <p
              style={{
                marginLeft: 5,
                fontSize: 12,
                fontWeight: 500,
                color: "#000a",
              }}
            >
              Informações do Lembrete
            </p>
          </header>

          <h2 style={{ marginTop: 10, fontSize: 22 }}>
            {reminderSelected.name}
          </h2>

          <div style={{ marginBottom: 20 }}>
            <span
              style={{
                background: "#f0f0f0",
                padding: "4px 12px",
                borderRadius: 50,
                fontSize: 11,
                fontWeight: "bold",
                color: "#555",
                textTransform: "uppercase",
              }}
            >
              {reminderSelected.type || "TASK"}
            </span>
          </div>

          <InfoTag>
            <div className="tag">
              <MdEventNote size={14} />{" "}
              {reminderSelected.date
                ? format(new Date(reminderSelected.date), "dd/MM/yyyy HH:mm")
                : "Sem data"}
            </div>
            <div className="tag">
              Status:{" "}
              <span
                style={{
                  color: reminderSelected.confirm
                    ? "#008037"
                    : isBefore(
                          new Date(reminderSelected.date),
                          startOfDay(new Date()),
                        )
                      ? "#ff4d4f"
                      : "#faad14",
                  fontWeight: "bold",
                  marginLeft: 5,
                }}
              >
                {reminderSelected.confirm
                  ? "Concluido"
                  : isBefore(
                        new Date(reminderSelected.date),
                        startOfDay(new Date()),
                      )
                    ? "Vencido"
                    : "Pendente"}
              </span>
            </div>
          </InfoTag>

          {reminderSelected.type !== "task" && (
            <div style={{ margin: "15px 0" }}>
              <p style={{ fontSize: 13, color: "#666", marginBottom: 5 }}>
                Vinculado a:
              </p>
              <Button
                type="primary"
                style={{ height: 30, fontSize: 13 }}
                onClick={() => {
                  if (reminderSelected.type === "order") {
                    navigate(`/cliente/os/${reminderSelected.order_id}`);
                  } else {
                    const foundLead = leadsAll.find(
                      (l) => l.id === reminderSelected.lead_id,
                    );
                    if (foundLead) {
                      setLeadSelected(foundLead);
                      setIsOpenLead(true);
                      setIsOpenDetails(false);
                    } else {
                      toast.warn("Lead não encontrado");
                    }
                  }
                }}
              >
                {reminderSelected.type === "order"
                  ? `OS: ${reminderSelected.order_id}`
                  : leadsAll.find((l) => l.id === reminderSelected.lead_id)
                      ?.name || "Ver Lead"}
              </Button>
            </div>
          )}

          <div style={{ margin: "15px 0" }}>
            <p style={{ fontSize: 13, color: "#666", marginBottom: 5 }}>
              Descrição:
            </p>
            <p style={{ fontSize: 14, fontWeight: "normal", color: "#333" }}>
              {reminderSelected.description || "Sem descrição adicional."}
            </p>
          </div>

          {reminderSelected.type == "order" &&
            reminderSelected.expiration_date && (
              <div style={{ margin: "15px 0" }}>
                <p style={{ fontSize: 13, color: "#666", marginBottom: 5 }}>
                  Data de Renovação:
                </p>
                <p style={{ fontSize: 14, fontWeight: "bold", color: "#333" }}>
                  {format(
                    new Date(reminderSelected.expiration_date),
                    "dd/MM/yyyy",
                  )}
                </p>
              </div>
            )}
        </div>
      </Modal>
    </Container>
  );
};

export default Lembretes;
